module.exports = __webpack_public_path__ + "static/media/08.e84f6112.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/presentare/08.jpg
// module id = 587
// module chunks = 0